import * as CL from '@design-system/component-library';
import { dsClass } from '../../../../../../common/constants/dsClasses';
import { copyUserInfoMsg, t } from '../../../../../../common/i18n';

interface CopyUserInfoButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const CopyUserInfoButton = ({ onClick, disabled = false }: CopyUserInfoButtonProps) => {
  return (
    <CL.Button color="link" onClick={onClick} disabled={disabled} className="copy-user-info-button" size="l">
      <CL.Icon icon="copy-clipboard" size="m" className={dsClass.MARGIN_RIGHT_2} />
      {t.GUWZ(copyUserInfoMsg)}
    </CL.Button>
  );
};
